import gql from 'graphql-tag';

const tagResourceMutation = gql`
  mutation TagResource($tagId: ID!, $resourceType: String!, $resourceId: ID!) {
    tagResource(tagId: $tagId, resourceType: $resourceType, resourceId: $resourceId)
  }
`;

export default {
  mutation: tagResourceMutation,
  module: 'tags',
  isSilent: true,
  buildVariables: ({ tagId, assetId }) => ({
    tagId,
    resourceType: 'ASSET',
    resourceId: assetId
  })
};